export class CurrentSessionData {
  public id: number = 0;
  public username: string = "";
  public password: string = "";

  /**
   *  Flag value; if the "rememberCredentials" function is toggled on in the "login-access-plant", then it is set to TRUE; otherewise, it is set FALSE.
   */
  public rememberCredentials: boolean = false;

  public accessToken: string = "";
  public refreshToken: string = "";

  /**Expiration date for ACCESS token, expressed as TIMESTAMP.
   *
   * ATTENTION: its computation is based on UTC time.
   */
  //public expireTokenAccessDate?: any = null;
  public expireTokenAccessDate?: number = null;

  /**Expiration date for ACCESS token, expressed as FORMATTED STRING-DATE.
   *
   * ATTENTION: DO NOT USE this to directly create a Moment() object; it shall be considered by default a local time-zone and NOT a UTC time.
   */
  public expireTokenAccessDateString: string = "";

  /**Expiration date for REFRESH token, expressed as TIMESTAMP.
   *
   * ATTENTION: its computation is based on UTC time.
   */
  //public expireTokenRefreshDate?: any = null;
  public expireTokenRefreshDate?: number = null;

  /**Expiration date for REFRESH token, expressed as FORMATTED STRING-DATE.
   *
   * ATTENTION: DO NOT USE this to directly create a Moment() object; it shall be considered by default a local time-zone and NOT a UTC time.
   */
  public expireTokenRefreshDateString: string = "";

  /**
   * Flag value; if the "auto-login" function is toggled on in the "login-access-plant", then it is set to TRUE; otherewise, it is set FALSE.
   */
  public isAutoLoginOn: boolean = false;
  public role: number = null;
  public name: string = "";
  public surname: string = "";

  public commercialComunication: boolean = false;
  public personalizingService: boolean = false;
  public idUserRemote: number = null;

  /**
   * Trial flag received from the login response; it is set to "S" when the account
   * is still on its trial period.
   */
  public trial: string = "";

  /**
   * Expiration date of the trial period, as received from the login response.
   */
  public expirationDate: string = "";

  constructor() {}
}
